export var PixelMode = /*#__PURE__*/function (PixelMode) {
  PixelMode["precise"] = "precise";
  PixelMode["percent"] = "percent";
  return PixelMode;
}(PixelMode || {});